import { Injectable, Injector } from '@angular/core';
import { TextBank } from '@authority-labs/api-interfaces';
import { Observable } from 'rxjs';
import { CrudService } from '../crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class TextBankService extends CrudService<TextBank> {
  constructor(injector: Injector) {
    super(injector, 'text-bank', TextBank);
  }

  updateSortOrder(
    items: { id: number; sortOrder: number }[]
  ): Observable<void> {
    return this.http.put<void>(`${this.api}/sort-order`, items);
  }
}
